'use strict';
const angular = require('angular');

export class UndoRedoComponent {

    selectedView: any;
    store: any;
    scope: any;
    $rootScope: any;
    stack: any = [];
    position = 0;
    limit = 11;
    views: any;


    constructor(localStorage, $scope, $rootScope) {
        let self = this;
        this.scope = $scope;
        this.store = localStorage;
        this.selectedView = this.store.get('selectedView');
        this.views = this.store.get('views');
        this.$rootScope = $rootScope;
        this.$rootScope.$on('newDesgin', function (event, args) {
            self.clear();
        });
        this.$rootScope.$on('designChanged', function (event, args) {
            self.remember();
        });
        this.$rootScope.$on('designViewAdded', (event, args) => {
            //this.stack[args.viewName] = [[]];
            //this.position[args.viewName] = 1;
        });
         
        this.$rootScope.$on('undoRedo', (event, args) => {
            if(args === 'UNDO') {
                this.undo();
            } else if(args === 'REDO') {
                this.redo();
            }
            this.scope.$apply();
        })

        this.stack = [];
        this.position = -1;
    }

    getCurrentViewName() {
        return this.selectedView.view.viewName;
    }

    remember() {
        let self = this;
        let object = {};
        for (let view in self.views) {
            let currentView = self.views[view].viewName;
            object[currentView] = angular.copy(self.views[view].controls.A);
        }
        this.stack.splice(this.position, this.limit);
        this.stack.push(object);
        this.stack.splice(0, this.stack.length - this.limit);
        this.position = this.stack.length;
    }

    undo() {
        let self = this;
        if (this.position > 1) {
            this.position--;
            let value = this.stack[this.position - 1];
            for (let view in self.views) {
                let currentView = self.views[view].viewName;
                if (value[currentView] !== undefined) {
                    self.views[view].controls.A = angular.copy(value[currentView]);
                }
            }
        }
    }

    redo() {
        let self = this;
        if (this.position < this.stack.length) {
            this.position++;
            let value = this.stack[this.position - 1];
            for (let view in self.views) {
                let currentView = self.views[view].viewName;
                if (value[currentView] !== undefined) {
                    self.views[view].controls.A = angular.copy(value[currentView]);
                }
            }
        }
    }

    clear() {
        this.stack = [];
        this.position = 0;
    }
}

export default angular.module('directives.undoredo', [])
    .component('undoredo', {
        template: require('./undo-redo.html'),
        controller: UndoRedoComponent,
        controllerAs: 'UndoCtrl'
    }).name;



// WEBPACK FOOTER //
// ./client/components/undo-redo/undo-redo.component.ts